export default __webpack_public_path__ + "static/media/guide2.596a08c6.webp";